import { FC, useState } from "react"

// components
import { InlineAlert, MegaphoneIcon, Button } from "@eventbrite/marmalade"

// data
import {
  InfoIcon,
  GlobeIcon,
  AlertOutlineIcon,
  FlagIcon,
  CheckIcon
} from "@eventbrite/marmalade"

// styles
import * as styles from "./Alert.module.scss"

// types
import { HelpArticleAlertData } from "../../utils/contentful/render_rich_text"
import {
  enhancedCustomRendererToRemovePTag,
  renderEnhancedRichText
} from "../../utils/contentful/enhanced-rich-text-renderer"

type Props = {
  alertData: HelpArticleAlertData
}

const alertTypeMap: Record<
  string,
  {
    icon: JSX.Element
    variant: "info" | "success" | "warning" | "danger" | "opportunity"
  }
> = {
  Info: {
    icon: <InfoIcon size="medium" />,
    variant: "info"
  },
  Warning: {
    icon: <FlagIcon size="medium" />,
    variant: "warning"
  },
  Danger: {
    icon: <AlertOutlineIcon size="medium" />,
    variant: "danger"
  },
  Success: {
    icon: <CheckIcon size="medium" />,
    variant: "success"
  },
  Availability: {
    icon: <GlobeIcon size="medium" />,
    variant: "info"
  },
  Tip: {
    icon: <MegaphoneIcon size="medium" />,
    variant: "opportunity"
  }
}

export const Alert: FC<Props> = ({ alertData }) => {
  const [isVisible, setIsVisible] = useState(true)

  const alertTypeKey = alertData?.alertTypeReference
    ?.alertTypeName as keyof typeof alertTypeMap
  const alertVariantInfo = alertTypeMap[alertTypeKey]
  const icon = alertVariantInfo?.icon
  const variant = alertVariantInfo?.variant

  if (!alertData?.alertDescription?.raw || !alertVariantInfo) {
    return null
  }
  if (!isVisible) {
    return null
  }

  return (
    <InlineAlert
      className={styles?.alertWrapper}
      title={alertData.alertHeader || ""}
      description={
        <>
          {renderEnhancedRichText(
            alertData.alertDescription.raw,
            enhancedCustomRendererToRemovePTag
          )}
        </>
      }
      icon={alertData.alertShowIcon ? icon : undefined}
      variant={variant}
      closeOnClick={
        alertData?.alertDismissBoolean
          ? () => {
              setIsVisible(false)
            }
          : undefined
      }
      cta={
        alertData.alertCta?.microcopyValue?.raw ? (
          <Button variant="ghost">
            {renderEnhancedRichText(
              alertData.alertCta?.microcopyValue?.raw || "",
              enhancedCustomRendererToRemovePTag,
              true
            )}
          </Button>
        ) : (
          <></>
        )
      }
    />
  )
}
